import React, { Component } from "react";

import { Link } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";

import Axios from "axios";
import { configuration } from "../appConfig";

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

export default class InsuranceProfile extends Component {
  state = {
    selectedFile: "",
    order: {
      vinNumber: "",
      orderNumber: Math.round(Math.random() * 100000000),
      issuedOn: new Date(),
    },
  };
  componentDidMount() {
    this.customerInfo();
    this.vinFolderList();
  }
  handleChange = (e) => {
    this.setState({
      customerInfo: {
        ...this.state.customerInfo,
        [e.target.name]: e.target.value,
      },
    });
  };
  customerInfo = async () => {
    //alert('No Partner Id selected! Please login.')

    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    if (partnerId) {
      const res = await Axios.get(
        configuration.getCustomerInfo +
          "?partnerId=" +
          partnerId +
          "&vin=" +
          vin
      );
      if (res.data.length) {
        this.setState({ customerInfo: res.data[0] });
      }
    } else {
      // this.props.history.push('/login');
      // alert('No Partner Id selected! Please login.')
    }
  };
  vinFolderList = async () => {
    const partnerId = localStorage.getItem("partnerId");
    if (partnerId) {
      const url = configuration.resultTxt;
      const response = await Axios.get(url + "?partnerId=" + partnerId);
      const vinAvg =
        response &&
        response.data &&
        response.data.result_data.length &&
        response.data.result_data.map((row) => {
          if (row.resultTXT && row.resultTXT.scanresult) {
            const sum = row.resultTXT.scanresult.reduce(
              (prv, current, arr) => parseInt(prv) + parseInt(current.Amount),
              0
            );
            const avg = sum / row.resultTXT.scanresult.length;
            return { avg: avg, vin: row.resultTXT.vin, dents: sum };
          } else {
            return {
              avg: "avg",
              vin: row.resultTXT ? row.resultTXT.vin : "",
              dents: "",
            };
          }
        });
      this.setState({ vinfolderList: vinAvg });
    } else {
      this.props.history.push("/login");
    }
  };

  selectFile = (e) => {
    localStorage.setItem("selectedFile", e.target.value);
    this.setState({ selectedFile: e.target.value });
  };
  showDummyData = () => {
    //this.getData(this.state.selectedFile);
    this.customerInfo();
  };

  render() {
    //const selectedFile = localStorage.getItem("selectedFile");
    const { orderNumber } = this.state.order;

    const fields = [
      {
        name: "company",
        value: "",
        type: "text",
        size: "4",
        title: "Insurance company",
        placeholder: "",
      },
      {
        name: "mailbox",
        value: "",
        type: "text",
        size: "4",
        title: "House No or Mailbox",
        placeholder: "",
      },
      {
        name: "email",
        value: "",
        type: "text",
        size: "4",
        title: "Email Address",
        placeholder: "",
      },
      {
        name: "adjuster",
        value: "",
        type: "text",
        size: "3",
        title: "Adjuster",
        placeholder: "",
      },
      {
        name: "insuranceNumber",
        value: "",
        type: "text",
        size: "3",
        title: "Insurance Number",
        placeholder: "",
      },
      {
        name: "claim",
        value: "",
        type: "text",
        size: "3",
        title: "Claim",
        placeholder: "",
      },
      {
        name: "deductable",
        value: "",
        type: "text",
        size: "3",
        title: "Deductable",
        placeholder: "",
      },
      {
        name: "city",
        value: "",
        type: "text",
        size: "3",
        title: "City",
        placeholder: "",
      },
      {
        name: "country",
        value: "",
        type: "text",
        size: "3",
        title: "Country",
        placeholder: "",
      },
      {
        name: "pincode",
        value: "",
        type: "text",
        size: "3",
        title: "Pincode",
        placeholder: "",
      },
      {
        name: "phone",
        value: "",
        type: "text",
        size: "3",
        title: "Phone",
        placeholder: "",
      },
    ];
    return (
      <div className="animated fadeIn">
        <div className="card">
          <Row>
            <Col md="12" sm="12">
              <Card>
                <CardHeader>
                  <small className="pull-right">Order No : {orderNumber}</small>
                  <small>
                    {" "}
                    VIN Number : {localStorage.getItem("selectedFile")}
                  </small>
                </CardHeader>
                <CardBody>
                  <FormGroup row className="my-0">
                    {fields.map((row) => (
                      <Col md={row.size}>
                        <FormGroup>
                          <Label>{row.title}</Label>
                          <Input
                            type="text"
                            id="city"
                            placeholder={row.placeholder}
                            onChange={this.handleChange}
                            value={row.value}
                            name={row.name}
                          />
                        </FormGroup>
                      </Col>
                    ))}

                    {/* <Col md="6">
                      <FormGroup>
                        <Label htmlFor="postal-code">Issued on</Label>
                        <Input
                          type="text"
                          id="postal-code"
                          placeholder="Issued On"
                          onChange={this.handleChange}
                          value={issuedOn}
                          name="issuedOn"
                        />
                      </FormGroup>
                    </Col> */}
                  </FormGroup>
                </CardBody>

                <div className="card-footer">
                  <button className="btn btn-danger btn-sm" onClick={this.save}>
                    Update Insurance
                  </button>
                  {/* <button className="btn btn-warning btn-sm">Action</button> */}

                  <Link className="glass" to="/VehicleCheckin">
                    <button className="btn btn-danger btn-sm pull-right">
                      <i className="fa fa-dot-circle-o"></i> {">>"}
                    </button>
                  </Link>

                  <Link className="glass" to="/order">
                    <button
                      className="btn btn-danger btn-sm pull-right"
                      style={{ marginRight: 10 }}
                    >
                      {"<<"} <i className="fa fa-dot-circle-o"></i>
                    </button>
                  </Link>
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

//export default Colors;
